import { render, staticRenderFns } from "./ClientOverview.vue?vue&type=template&id=56e76c7b&scoped=true"
import script from "./ClientOverview.vue?vue&type=script&lang=js"
export * from "./ClientOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e76c7b",
  null
  
)

export default component.exports